import React from 'react';
import { Container, Row, Column, Direction, Justify } from '@uds/grid';
import Background, { BackgroundArray } from 'components/common/Background';

import Body, { OuterProps as BodyProps } from '../Body';
import Scroll from '../Scroll';
import Tiles from '../Tiles';
import { Side as TilesSide } from '../constants';
import useStylesheet from './WithTiles.stylesheet';
import { TileProps } from '../Tile';

interface OuterProps extends BodyProps {
  showScroll: boolean;
  background: BackgroundArray;
  onScrollClick: (evt: any) => any;
  justify: Justify;
  hideGradient?: boolean;
  tiles: Array<TileProps>;
}

export const PureBillboardTiles = ({
  layout,
  colorway,
  hBaseline = 0,
  ctas,
  text,
  additionalText,
  footerText,
  tiles,
  onScrollClick,
  justify,
  showScroll,
  ribbonId,
  background,
  hideGradient,
}: OuterProps) => {
  const { styles } = useStylesheet({ layout });
  const direction = layout.tilesSide === TilesSide.END ? Direction.ROW : Direction.ROW_REVERSE;

  return (
    <div style={styles.container}>
      <div style={styles.row}>
        <Row vblock={true} justify={justify} direction={direction}>
          <Column lg={6} gutters={false}>
            <Background
              hideGradient={hideGradient}
              background={background}
              layout={layout}
              colorway={colorway}
              hasTiles={true}
            />
            <div style={styles.content}>
              <Container>
                <Body
                  colorway={colorway}
                  ribbonId={ribbonId}
                  text={text}
                  additionalText={additionalText}
                  footerText={footerText}
                  ctas={ctas}
                  layout={layout}
                  hBaseline={hBaseline}
                />
                {showScroll && <Scroll onScrollClick={onScrollClick} layout={layout} />}
              </Container>
            </div>
          </Column>
          <Column lg={6} gutters={false}>
            <Tiles layout={layout} tiles={tiles} hBaseline={hBaseline} />
          </Column>
        </Row>
      </div>
    </div>
  );
};

PureBillboardTiles.displayName = 'BillboardTiles';

export default PureBillboardTiles;
